import React, { useState, useEffect } from 'react'
import CustomLoader from '../../../Common/CustomLoader'
import { resetCardAlert, updateTimeZone } from '../../../../store/actions'
import * as Yup from "yup"
import { useFormik } from 'formik'
import form_messages from '../../../../constants/form_messages'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'reactstrap'
import { v4 as uuidv4 } from 'uuid';
import { CustomToast } from '../../Common/CustomToast'



const TimeZone = ({ hideHeading, timeZonesDetails }) => {
    const { loading, listofTimeZones, responseMessage, responseStatus, selectedTimeZone, updateTimeZoneLoading } = timeZonesDetails
    const [edited, setedited] = useState(false)
    const dispatch = useDispatch();
    const timezoneslist = listofTimeZones?.map(ele => { return { id: uuidv4(), name: ele.timezone } })
    const [timezoneSelected, setTimeZoneSelected] = useState("")
    const { timezone } = useSelector(state => state.Login.constDetails)



    useEffect(() => {
        setTimeZoneSelected(selectedTimeZone ? selectedTimeZone : timezone ? timezone : timezoneslist && timezoneslist[0]?.name
        )
    }, [selectedTimeZone, timezoneslist, timezone])


    useEffect(() => {
        if (responseMessage) {
            CustomToast({
                message: responseMessage,
                status: responseStatus ? 'success' : 'failure',
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            if (responseStatus) {
                setedited(false)
            }
            dispatch(resetCardAlert())
        }
    }, [responseMessage])

    const validationType = useFormik({
        enableReinitialize: true,

        initialValues: {
            time_zone: timezoneSelected ? timezoneSelected : "",
        },
        validationSchema: Yup.object().shape({
            time_zone: Yup.string().required(form_messages.Billing_Address.Country_name.REQUIRED).trim(),
        }),
        onSubmit: values => {
            dispatch(updateTimeZone({ timezone: values?.time_zone }))
        },
    })
    return (
        <React.Fragment>
            {loading ? <div className='mt-3'><CustomLoader text={"Fetching timezones list..."} /></div> : <div className="billing-address-details">
                {!hideHeading && (
                    <div className="mt-3">
                        <div className="billing-details d-flex align-items-center justify-content-between">
                            <div className='timezone'>
                                <Form
                                    className='form-billing-address custom-validation'
                                >
                                    <div >

                                        <div className='form-filed'>
                                            <span className={(!edited) ? `input-title-view` : `input-title`}>Timezone </span>
                                            {edited ?
                                                (<div>
                                                    <select
                                                        name="time_zone"
                                                        id=""
                                                        className={`input-value-filed ${validationType.touched.time_zone &&
                                                            validationType.errors.time_zone && `error-border`}`}
                                                        onChange={(e) => {
                                                            console.log('eeeeeeeeeeee', e.target)
                                                            e.target.value = e.target.value;
                                                            validationType.handleChange(e);
                                                        }}
                                                        onBlur={validationType.handleBlur}
                                                        value={validationType.values.time_zone || ""}
                                                    >
                                                        {timezoneslist?.map(timezone => (
                                                            <option
                                                                value={timezone.name}
                                                                key={timezone.id}
                                                            >
                                                                {`${timezone.name}`}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {validationType.touched.time_zone &&
                                                        validationType.errors.time_zone ? (
                                                        <div className='error-msg'>
                                                            {validationType.errors.time_zone}
                                                        </div>
                                                    ) : null}
                                                </div>) :
                                                <div className='input-value-filed-value'>{timezoneSelected}</div>
                                            }
                                        </div>


                                    </div>

                                </Form>

                            </div >
                            <div className='d-flex'>
                                {edited && <button className='btn-cancel' type='button' onClick={() => {
                                    setedited(false)
                                    validationType.resetForm()
                                }}>Cancel</button>}
                                {(!edited) && <button className="btn-save me-0" type='button' onClick={(e) => {
                                    setedited(true)
                                    return false
                                }}>Edit</button>}
                                {(edited) && <button disabled={updateTimeZoneLoading} className={`${updateTimeZoneLoading ? "btn-save me-0 button-disabled" : "btn-save me-0"}`} type='submit' onClick={(e) => {
                                    e.preventDefault()
                                    validationType.handleSubmit()
                                    return false
                                }}>Save
                                    {/* {updateTimeZoneLoading ? <SmallLoader /> : `Save`} */}
                                    {updateTimeZoneLoading &&
                                        <div className="spinner-container spinner-border">
                                        </div>}
                                </button>}
                            </div>
                        </div>
                    </div>
                )}


            </div >}
        </React.Fragment >
    )
}
export default TimeZone;